import React from 'react';
import styled from 'styled-components';
import { colors } from '../../styles/colors';

const WAIT_BEFORE_CLOSING_MS = 100;

export type HeaderDropdownProps = {
  selected: string;
  options: DropdownItem[];
  callback: (e: React.MouseEvent<HTMLDivElement, MouseEvent>, selectedItem: string) => void;
};

export type DropdownItem = {
  title: string;
  value: string;
};

type State = {
  lastMouseIn: number;
  expanded: boolean;
  selectedItem: string;
};

export default class HeaderDropdown extends React.PureComponent<HeaderDropdownProps, State> {
  constructor(props: HeaderDropdownProps) {
    super(props);
    this.state = {
      lastMouseIn: 0,
      expanded: false,
      selectedItem: props.selected,
    };
  }

  onSelect(e: React.MouseEvent<HTMLDivElement, MouseEvent>, selectedItem: string) {
    this.setState({ selectedItem, expanded: false });
    this.props.callback(e, selectedItem);
  }

  expand() {
    this.setState({ lastMouseIn: Date.now(), expanded: true, });
  }

  async collapse() {
    const mouseOutTime = Date.now();
    await new Promise(resolve => setTimeout(resolve, WAIT_BEFORE_CLOSING_MS));
    if (this.state.lastMouseIn <= mouseOutTime) {
      this.setState({ expanded: false });
    }
  }

  render() {
    const { options } = this.props;
    return (
      <HeaderDropdownContainer onMouseOver={() => this.expand()} onMouseLeave={() => this.collapse()}>
        <SelectedItem className="selected-item">{(options.find(item => item.value === this.state.selectedItem) || { title: '' }).title}</SelectedItem>
        {
          this.state.expanded
            ? <OptionList>
              {
                options.map((o, i) =>
                  <div className="option" key={i} onClick={(e) => this.onSelect(e, o.value)}>
                    {o.title}
                  </div>)
              }
            </OptionList>
            : undefined
        }
      </HeaderDropdownContainer>
    );
  }
}

const HeaderDropdownContainer = styled.div`
    position: relative;
    margin-right:3em;
`;

const SelectedItem = styled.div`
    cursor: pointer;
    padding-left: 1em;
    font-weight: bold;

    &::after {
        border: 0.25em solid transparent;
        border-top-color: black;
        content: '';
        position: absolute;
        top: calc(50% - 2px);
        right: -0.75em;
    }
`;

const OptionList = styled.div`
    z-index: 99999;
    &::after,
    &::before {
        width: 0;
        height: 0;
        display: block;
        position: absolute;
        content: '';
    }

    &::before {
        border-left: 10px solid transparent;
        border-right: 10px solid transparent;
        border-bottom: 8px solid hsla(0, 0, 50%, 0.24);
        left: calc(50% - 10px);
        top: -10px;
    }

    &::after {
        border-left: 8px solid transparent;
        border-right: 8px solid transparent;
        border-bottom: 7px solid white;
        top: -7px;
        left: calc(50% - 8px);
    }

    position: absolute;
    top: 2em;
    left: -1em;
    box-shadow: 0 0 4px rgba(0, 0, 0, 0.33);
    padding: 0.5em 2em;
    background: white;

    .option {
        transition: color 0.1s;
        cursor: pointer;
        white-space: nowrap;

        &:not(:last-child) {
            margin-bottom: 0.5em;
        }

        &:hover {
            cursor: pointer;
            color: ${colors.blue};
        }
    }
`;